import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import SiteHeader from './SiteHeader';
import AdminActivity from './AdminActivity';
import AdminPeople from './AdminPeople';
import AdminInvites from './AdminInvites';
import AdminRoster from './AdminRoster';
import AdminTrails from './AdminTrails';
import AdminTrainEnvs from './AdminTrainEnvs';

type Tab = 'roster' | 'people' | 'activity' | 'invites' | 'trails' | 'environments';

export default function AdminPage() {
  const [tab, setTab] = useState<Tab>('roster');

  return (
    <div className="min-h-screen bg-paper-50 dark:bg-clay-floor">
      <SiteHeader />
      <main className="mx-auto max-w-[1600px] px-3 pb-16 pt-4 lg:px-6">
        <Link
          to="/"
          className="inline-flex items-center gap-1 text-sm text-ink-400 hover:text-terracotta-600"
        >
          <ArrowLeft className="h-4 w-4" /> Home
        </Link>

        <div className="mt-3 flex items-center gap-2">
          <Shield className="h-5 w-5 text-terracotta-500" />
          <h1 className="text-xl font-semibold text-ink-900 dark:text-paper-50">
            Khalifa — manage the akhara
          </h1>
        </div>

        {/* Tab toggle — same style as Dangal's scope toggle */}
        <div className="mt-4 flex flex-wrap gap-0.5 rounded-lg border border-rule bg-paper-0 p-0.5 text-sm dark:border-clay-rule dark:bg-clay-surface">
          {(
            [
              ['roster', 'People'],
              ['people', 'Access'],
              ['invites', 'Invites'],
              ['trails', 'Kushtis'],
              ['environments', 'Mittis'],
              ['activity', 'Activity'],
            ] as const
          ).map(([t, label]) => (
            <button
              key={t}
              onClick={() => setTab(t)}
              className={`rounded-md px-3 py-1 font-medium transition ${
                tab === t
                  ? 'bg-terracotta-500 text-white'
                  : 'text-ink-500 hover:text-ink-900 dark:text-paper-300'
              }`}
            >
              {label}
            </button>
          ))}
        </div>

        <div className="mt-4">
          {tab === 'roster' && <AdminRoster />}
          {tab === 'people' && <AdminPeople />}
          {tab === 'invites' && <AdminInvites />}
          {tab === 'trails' && <AdminTrails />}
          {tab === 'environments' && <AdminTrainEnvs />}
          {tab === 'activity' && <AdminActivity />}
        </div>
      </main>
    </div>
  );
}
